<div class="tw-relative" *ngIf="show && hasTestUrls" id="survey-preview-dropdown">
  <button
    mhFilterTrigger
    [filterIconOnly]="true"
    [filterOpen]="isOpen"
    type="button"
    (click)="toggleDropdown()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [mhTooltip]="'header.tooltips.view_survey' | translate"
    width="tw-w-fit"
    position="above"
  >
    <i class="far fa-eye tw-text-neutral-500"></i>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="tw-transparent"
    (backdropClick)="closeDropdown()"
    (detach)="closeDropdown()"
  >
    <div class="tw-rounded-lg tw-shadow-xl tw-p-1 tw-bg-white tw-mt-1 tw-min-w-[200px]">
      <div class="tw-flex tw-flex-col tw-gap-1">
        <button 
          *ngFor="let item of test_urls; let last = last; trackBy: trackByLanguageId"
          type="button"
          (click)="handleOpenPreview(item.url); closeDropdown()"
          class="tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-100 tw-rounded tw-transition-colors tw-block tw-no-underline hover:tw-no-underline tw-text-left"
          [class.tw-border-b]="!last"
          [class.tw-border-gray-200]="!last"
        >
          {{ 'languages.id.' + item.language_id | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</div>
